/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientRecentViews = sqliteTable('patient_recent_views', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  user_id: text('user_id'),
  patient_id: text('patient_id'),
  viewed_at: text('viewed_at'),
});
